<template>
<div>
    <GoogleMapLoader
        ref="mapLoader"
        :api-key="apiKey"
        :map-config="mapConfig"
        @gmap:initialized="$emit('map:initialized', $event)"
    >
        <template slot-scope="{ google, map }">
            <GoogleMapMarker
                :marker="markerKioskConfig"
                :google="google"
                :map="map"
                :visible="true"
                :icon="{ url: '/img/ui/marker-hell.svg', w: 88, h: 107 }"
            />
            <GoogleMapCluster
                ref="mapCluster"
                :markers="markers"
                :google="google"
                :map="map"
                :objetTouristique="objetTouristique"
                @marker:click="onMarkerClick"
                @bounds:minzoom="onMinZoomReceived"
            />
            <GoogleMapDirection
                v-if="objetTouristique"
                :google="google"
                :map="map"
                :center="{ lat: kiosk.geolocation.lat, lng: kiosk.geolocation.long }"
                :objetTouristique="objetTouristique"
            />
        </template>
    </GoogleMapLoader>

    <MapActions v-if="kiosk" @mapaction:zoom="onZoomEvent" @mapaction:center="onCenterEvent" />
</div>
</template>

<script>
import styles from '../../../../json/map-styles.json'
import GoogleMapLoader from './GoogleMapLoader.vue'
import GoogleMapCluster from './GoogleMapCluster.vue'
import GoogleMapMarker from './GoogleMapMarker.vue'
import GoogleMapDirection from './GoogleMapDirection.vue'
import MapActions from './MapActions.vue'

export default {
    name: 'Map',

    components: {
        GoogleMapLoader,
        GoogleMapCluster,
        GoogleMapMarker,
        GoogleMapDirection,
        MapActions,
    },

    props: {
        kiosk: { type: Object, required: true },
        objetsTouristiques: { type: Array, required: true },
        objetTouristique: { type: Object, required: false },
    },

    data() {
        return {
            minZoom: this.kiosk.minZoom,
            apiKey: process.env.MIX_GOOGLE_CLOUD_KEY_FRONTEND,
        }
    },

    computed: {
        mapConfig() {
            console.log(process.env)
            return {
                center: { lat: this.kiosk.geolocation.lat, lng: this.kiosk.geolocation.long },
                zoom: this.kiosk.minZoom,
                minZoom: 8,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                disableDefaultUI: true,
                styles,
            }
        },
        markers() {
            return this.objetsTouristiques.map(obj => ({
                id: `${obj.id}_${obj.selectionId}`,
                objId: `${obj.id}`,
                selectionId: `${obj.selectionId}`,
                position: { lat: obj.geolocation.lat, lng: obj.geolocation.long },
                icon: obj.icon,
                isVisible: obj.isVisible,
            }))
        },

        markerKioskConfig() {
            return {
                id: 'kioskpoint',
                position: { lat: this.kiosk.geolocation.lat, lng: this.kiosk.geolocation.long },
            }
        },
    },

    methods: {
        onMarkerClick(markerData) {
            this.$emit('marker:click', this.objetsTouristiques.find(obj => obj.id === parseInt(markerData.objId, 10) && obj.selectionId === parseInt(markerData.selectionId, 10)))
        },

        onZoomEvent(inc) {
            const newZoom = this.$refs.mapLoader.map.getZoom() + inc
            this.$refs.mapLoader.map.setZoom(newZoom)
        },

        onCenterEvent() {
            this.reset()
        },

        onMinZoomReceived(minZoom) {
            this.$refs.mapLoader.map.setOptions({ minZoom })
        },

        reset() {
            const currentLatLng = this.$refs.mapLoader.map.getCenter()
            if (currentLatLng.lat() !== this.mapConfig.center.lat || currentLatLng.lng() !== this.mapConfig.center.lng) {
                this.$refs.mapLoader.map.setCenter(this.mapConfig.center)
            }
            this.$refs.mapCluster.fitMapToMarkers()
        },
    },
}
</script>
